import gmap from '@app/Map/ContactsMap'

export default function install(Vue) {
  Vue.component('ContactsMap', gmap)
}
